// src/components/home/HomeJournal.jsx

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "./css/HomeJournal.css";

import { supabase } from "../../lib/supabaseClient";

const HomeJournal = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadLatestArticles = async () => {
      const { data, error } = await supabase
        .from("journal_articles")
        .select(`
          id,
          title,
          slug,
          excerpt,
          cover_image,
          category,
          published_at
        `)
        .eq("published", true)
        .order("published_at", {
          ascending: false,
        })
        .limit(3);

      if (error) {
        console.error(
          "Error loading journal articles:",
          error
        );

        setLoading(false);
        return;
      }

      setArticles(data || []);
      setLoading(false);
    };

    loadLatestArticles();
  }, []);

  return (
    <section className="home-journal">

      <div className="home-container">

        <div className="home-section-heading journal-heading">

          <div>

            <span className="home-section-eyebrow">
              FROM THE JOURNAL
            </span>

            <h2>
              Ayurveda,
              <br />
              <em>explained thoughtfully.</em>
            </h2>

          </div>

          <p>
            Thoughtful perspectives on Ayurveda,
            health, lifestyle and practical knowledge
            from clinical practice.
          </p>

        </div>


        {!loading && articles.length > 0 && (

          <div className="journal-placeholder-grid">

            {articles.map((article) => (

              <Link
                to={`/journal/${article.slug}`}
                className="journal-placeholder"
                key={article.id}
              >

                <span>
                  {article.category || "AYURVEDA"}
                </span>

                <h3>
                  {article.title}
                </h3>

                {article.excerpt && (
                  <p>
                    {article.excerpt}
                  </p>
                )}

                <div className="home-journal-read-more">
                  Read Article
                  <span>→</span>
                </div>

              </Link>

            ))}

          </div>

        )}

        {!loading && articles.length === 0 && (

          <div className="home-journal-empty">
            <p>
              New articles and insights from our practice
              will appear here soon.
            </p>
          </div>

        )}

      </div>

    </section>
  );
};

export default HomeJournal;